import { render, staticRenderFns } from "./zlzxwyh.vue?vue&type=template&id=70b6f179&scoped=true"
import script from "./zlzxwyh.vue?vue&type=script&lang=js"
export * from "./zlzxwyh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6f179",
  null
  
)

export default component.exports